import { Avatar, Tooltip, Typography } from '@getsynapse/design-system';
import userAvatar from 'assets/icons/user-avatar.svg';
import intl from 'react-intl-universal';
import classNames from 'classnames';

interface Props {
  className?: string;
  size?: 'small' | 'medium' | 'large';
  hideName?: boolean;
  showTooltip?: boolean;
  content?: string;
}

export const DeletedUser = ({
  className,
  size,
  hideName,
  showTooltip,
  content,
}: Props) => {
  return (
    <Tooltip
      openMode='hover1'
      position='topCenter'
      contentProps={{
        className: 'bg-neutral-darker shadow-tooltip z-50',
      }}
      timeout={0}
      showPopper
      className='w-full truncate'
      usePortal
      trigger={
        <div className='flex gap-2.5 items-center'>
          <Avatar
            className={classNames('border-neutral-white bg-neutral', className)}
            imageSrc={userAvatar}
            size={size}
            showTooltip={false}
          />

          {!hideName && (
            <Typography variant='body2' className='text-neutral-dark'>
              {content || intl.get('DELETED_USER')}
            </Typography>
          )}
        </div>
      }
    >
      {showTooltip && (content || intl.get('DELETED_USER'))}
    </Tooltip>
  );
};
